import { render } from "./Home.vue?vue&type=template&id=0a687fc6&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=0a687fc6&lang=scss&scoped=true"

import exportComponent from "/media/myr/DATA/WEBS/DULCESDE.COM/NUEVA WEB 2022/vue_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a687fc6"]])

export default __exports__